var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTableSort = function SvgTableSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58178 10.2891L3.63178 13.8641C3.55748 13.947 3.45143 13.9943 3.34011 13.9943C3.2288 13.9943 3.12274 13.947 3.04845 13.8641L0.0984455 10.2891C-0.00061778 10.1783 -0.024955 10.0196 0.0363932 9.88423C0.0977414 9.7489 0.233203 9.66256 0.381779 9.66408H6.29845C6.44702 9.66256 6.58248 9.7489 6.64383 9.88423C6.70518 10.0196 6.68084 10.1783 6.58178 10.2891Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58178 3.70506L3.63178 0.130058C3.55748 0.047164 3.45143 -0.000201702 3.34011 -0.000201702C3.2288 -0.000201702 3.12274 0.047164 3.04845 0.130058L0.0984455 3.70506C-0.00061778 3.8158 -0.024955 3.97458 0.0363932 4.10991C0.0977414 4.24524 0.233203 4.33158 0.381779 4.33006H6.29845C6.44702 4.33158 6.58248 4.24524 6.64383 4.10991C6.70518 3.97458 6.68084 3.8158 6.58178 3.70506Z",
    fill: "currentColor"
  })));
};

export default SvgTableSort;